import DischargeTableController from './table.controller';

const template = require<string>('./table.html');

const bindings:{[key:string]: string} = {
  minX: '<',
  maxX: '<',
  dischargeModel: '<'
};

export default {
  bindings: bindings,
  controller: DischargeTableController,
  template
}



/** WEBPACK FOOTER **
 ** ./app/discharge/table.component.ts
 **/